import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://danni.narodnichitalishta.bg/api';

export const municipalityApi = createApi({
  reducerPath: 'municipalityApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Municipalities', 'Municipality', 'Chitalishta'],
  endpoints: (builder) => ({
    getMunicipalities: builder.query({
      query: ({ page = 1, pageSize = 20, sortBy = 'municipality', sortDir = 'asc' } = {}) => ({
        url: '/municipalities',
        params: { page, size: pageSize, sort: `${sortBy},${sortDir}` },
      }),
      providesTags: ['Municipalities'],
    }),
    
    getMunicipality: builder.query({
      query: (id) => `/municipalities/${id}`,
      providesTags: (result, error, id) => [{ type: 'Municipality', id }],
    }),
    
    getMunicipalityMetrics: builder.query({
      query: (id) => `/municipalities/${id}/metrics`,
      providesTags: (result, error, id) => [{ type: 'Municipality', id }],
    }),
    
    searchMunicipalities: builder.query({
      query: (query) => `/municipalities/search?q=${query}`,
      providesTags: ['Municipalities'],
    }),
    
    getMunicipalityChitalishta: builder.query({
      query: (municipalityId) => `/municipalities/${municipalityId}/chitalishta`,
      providesTags: ['Chitalishta'],
    }),
    
    getMunicipalityStatistics: builder.query({
      query: () => '/municipalities/statistics',
    }),
    
    updateMunicipality: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/municipalities/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Municipality', id },
        'Municipalities',
      ],
    }),
    
    getFilterOptions: builder.query({
      query: () => '/municipalities/filters/options',
    }),
    
    exportMunicipalities: builder.mutation({
      query: (format = 'csv') => ({
        url: '/municipalities/export',
        method: 'POST',
        body: { format },
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetMunicipalitiesQuery,
  useGetMunicipalityQuery,
  useGetMunicipalityMetricsQuery,
  useSearchMunicipalitiesQuery,
  useGetMunicipalityChitalishtaQuery,
  useGetMunicipalityStatisticsQuery,
  useUpdateMunicipalityMutation,
  useGetFilterOptionsQuery,
  useExportMunicipalitiesMutation,
} = municipalityApi;